__turbopack_context__.v({
  "left": "YellowCta-module___PRrta__left",
  "right": "YellowCta-module___PRrta__right",
  "wrapper": "YellowCta-module___PRrta__wrapper",
  "yellow__cta": "YellowCta-module___PRrta__yellow__cta",
});
